import * as z from "zod";

const schema = z.object({
	yearMonth: z.string(),
	sumOfVisitAndCounsel: z.number(),
	sumOfVisit: z.number(),
	sumOfEtc: z.number()
});

const model = schema.transform((values) => ({
	...values
}));

export const DetailModel = {schema, model};
export type IDetailModel = z.infer<typeof DetailModel.model>;
export const DEFAULT_DETAIL: IDetailModel = {
	yearMonth: "",
	sumOfVisitAndCounsel: 0,
	sumOfVisit: 0,
	sumOfEtc: 0
};
